export default class {

    SelectedStatus = null;

    Users = [];

    mapFromDto(usersDto) {
        if(!usersDto)
        return this;

        this.Users = usersDto;
        return this;
    }

    isExistsArchival() {
        return this.Users.some(e => e.Status == 2);
    }

    isExistsActive() {
        return this.Users.some(e => e.Status == 1);
    }

    selectArchival() {
        this.SelectedStatus = 2;
    }

    selectActive() {
        this.SelectedStatus = 1;
    }

    selectAll() {
        this.SelectedStatus = null;
    }

    isSelectedAll () {
        return !this.SelectedStatus;
    }

    isSelectedArchival() {
        return this.SelectedStatus == 2;
    }

    isSelectedActive() {
        return this.SelectedStatus == 1;
    }

    filterByStatus() {
        return this.Users.filter(e => e.Status == this.SelectedStatus);
    }

}